export const PROJECT_BITRIX = 'bitrix'
export const PROJECT_SAMOLET = 'samolet'

export type ProjectMode = typeof PROJECT_BITRIX | typeof PROJECT_SAMOLET

/**
 * Определяет режим meet по query-параметру project.
 */
export function resolveProjectMode(
  queryProject: string | string[] | undefined | null,
): ProjectMode | null {
  const value = typeof queryProject === 'string' ? queryProject.trim() : null

  if (value === PROJECT_BITRIX || value === PROJECT_SAMOLET) {
    return value
  }

  return null
}

/** Нужно ли пропустить Platform check_meet для данного режима. */
export function shouldSkipCheckMeet(mode: ProjectMode | null): boolean {
  return mode === PROJECT_BITRIX || mode === PROJECT_SAMOLET
}

/** Показывать ли поле телефона на prejoin. */
export function shouldShowPhoneField(mode: ProjectMode | null): boolean {
  return mode === PROJECT_SAMOLET
}

/** Нужно ли вызывать prejoin_check перед входом. */
export function shouldRunPrejoinCheck(mode: ProjectMode | null): boolean {
  return mode !== PROJECT_BITRIX
}

/** Показывать ли блок инструкций Самолёта на prejoin. */
export function shouldShowSamoletInstructions(mode: ProjectMode | null, v: string | null): boolean {
  return mode === PROJECT_SAMOLET && v !== 'hr'
}

/** Показывать ли текст пользовательского соглашения Самолёта. */
export function shouldShowSamoletTerms(mode: ProjectMode | null): boolean {
  return mode === PROJECT_SAMOLET
}

/** Загружать ли данные через ветку assistant-back / HURMA (samolet). */
export function isSamoletProjectMode(mode: ProjectMode | null): boolean {
  return mode === PROJECT_SAMOLET
}

/** Загружать ли данные через meet-client-api (bitrix). */
export function isBitrixProjectMode(mode: ProjectMode | null): boolean {
  return mode === PROJECT_BITRIX
}
